<template>
  <USelect
    :model-value="locale"
    :items="opciones"
    value-key="value"
    size="sm"
    variant="ghost"
    :aria-label="t('nav.language')"
    class="w-auto"
    @update:model-value="cambiar"
  />
</template>

<script setup lang="ts">
/**
 * Selector de idioma.
 *
 * Cambia de idioma NAVEGANDO a la URL del otro locale (`/` ↔ `/en/`), no sólo
 * cambiando el estado: con `prefix_except_default` cada idioma tiene su propia
 * dirección, y si no se navega el contenido cambiaría pero la URL diría otra cosa
 * — que es lo que rompe el compartir un enlace y lo que confunde a Google.
 *
 * `setLocale` del módulo ya escribe la cookie `factorix_lang`, así que la elección
 * manual le gana a la detección del navegador en las visitas siguientes.
 */
const { locale, locales, setLocale, t } = useI18n()

const opciones = computed(() =>
  (locales.value as { code: string; name?: string }[]).map(l => ({
    label: l.name || l.code.toUpperCase(),
    value: l.code,
  }))
)

async function cambiar(codigo: unknown) {
  const code = String(codigo)
  if (code && code !== locale.value) {
    await setLocale(code as 'es' | 'en')
  }
}
</script>
